import type { Holding } from '@/hooks/portfolio/usePortfolio';

export const isIncompleteManualPortfolio = (holdings: Holding[]) => {
  const incompleteHoldingCount = holdings.filter((n) => {
    if (n.units === 0) return true;
    if (n.averagePurchasePrice === null) return true;
  }).length;
  return {
    incomplete: incompleteHoldingCount > 0,
    incompleteHoldingCount,
  };
};
